import React from 'react';
import PropTypes from 'prop-types';
import DropDown from '../dropdown/Dropdown';
import { flattenChildren, isType } from '../../../../utils/react-children-utils/react-children-utils';

const AusStateDropdown = function AusStateDropdown(props) {
    const {
        children,
        validation,
        invalidclass,
    } = props;

    const input = flattenChildren(children).find((c) => isType(c, 'input'));

    const value = input.props.defaultValue ?? 'NSW';

    return (
        <DropDown
            name={input.props.name}
            placeholder=""
            validation={validation}
            defaultValue={value}
            invalidclass={invalidclass}
            options={['NSW', 'QLD', 'NT', 'WA', 'SA', 'VIC', 'ACT', 'TAS']}
        />
    );
};

AusStateDropdown.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    invalidclass: PropTypes.string,
};

AusStateDropdown.defaultProps = {
    validation: () => { },
    invalidclass: '',
};

export default AusStateDropdown;
